import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyName: "",
  email: "",
  firstName: "",
  lastName: "",
  role: "",
  uid: "",
};

export const usersSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.companyName = action.payload.companyName;
      state.email = action.payload.email;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.role = action.payload.role;
      state.uid = action.payload.uid;
    },
  },
});

export const SelectUser = (state) => state.user;

export const { setUserInfo } = usersSlice.actions;

export default usersSlice.reducer;
